import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpTV'


export const applicationList = (params = '') => Http.get(`/admin/streamers-applications${serialize(params)}`)

export const applicationCreate = (params = '') => Http.post('/admin/streamers-applications', params)
export const applicationByID = (params = '') => Http.get(`/admin/streamers-applications/${params}`)
export const applicationUpdate = (params = '') => Http.put(`/admin/streamers-applications/${params.id}`, params)
export const applicationDestroy = (params = '') => Http.delete(`/admin/streamers-applications/${params.id}`)